'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('user-type', {
    url: '/user/type/',
    templateUrl: '/views/user-type.html',
    controller: 'UserTypeCtrl',
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('User Type - Opencare');
      },
    },
    data: {
      hideNavigation: true,
    },
  });
});

angular.module('ClinicApp').controller('UserTypeCtrl', function($scope, $location, CurrentUser, UserService) {

  $scope.logout = function() {
    UserService.logout().then(function() {
      CurrentUser.update(function() {
        var nextUrl = $location.search().nextUrl;
        if (nextUrl) {
          $location.url(decodeURIComponent(nextUrl));
        } else {
          $location.path('/');
        }
      });
    });
  };

});
